<template>
  <CoreDialog
    data-qa="club-info-modal"
    :value="isTopDialog(componentName)"
    size="fullscreen"
    :title="title"
    no-click-animation
    persistent
    divider
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="handleInfoModalClose"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>
    <slot />
  </CoreDialog>
</template>

<script>
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'

import ModalManager from 'www/vue_components/common/mixins/DialogManager'
import ClubInfoModalLogicV2
  from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalLogicV2'

export default {
  name: 'ClubInfoModal',
  components: {
    CoreDialog,
  },
  mixins: [
    ModalManager,
    ClubInfoModalLogicV2,
  ],
}
</script>
